<nz-select
  nzShowSearch
  nzServerSearch
  [nzAllowClear]="true"
  [nzBackdrop]="addBackdrop"
  [nzFilterOption]="nzFilterOption"
  (nzOnSearch)="search($event)"
  (nzOpenChange)="search('')"
  (nzScrollToBottom)="loadMore()"
  [nzCustomTemplate]="displayTpl"
  [(ngModel)]="value"
  (ngModelChange)="valueChanged($event)"
  [nzDropdownMatchSelectWidth]="false"
  [nzBorderless]="borderless"
  nzDropdownClassName="dropdownSelect"
  class="width-100"
>
  <ng-template #displayTpl let-selected>
    {{ selected.nzLabel }}
  </ng-template>
  <ng-container *ngFor="let o of list">
    <nz-option *ngIf="!searching" [nzValue]="o[valueField]" [nzLabel]="o.docCode" nzCustomContent>
      <app-doc-select-item
        [code]="o.docCode"
        [currency]="o.currency?.code"
        [amount]="o.totalDebit"
        [company]="o.description"
        [date]="o.docDate"
      >
      </app-doc-select-item>
    </nz-option>
  </ng-container>
</nz-select>
<ng-template #loadingTpl>
  <div *ngIf="searching">
    <nz-spin></nz-spin>
    Loading
  </div>
</ng-template>
